import React from 'react';
import SimpleModal from "./simple-modal";

const DeleteItemLink = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return this.state.isModalOpen || nextState.isModalOpen;
  },
  getInitialState: function() {
    return { isModalOpen: false };
  },
  render: function() {
    const { heading, body, linkText, hideIcon } = this.props;
    return (
      <a onClick={this.openModal} href="#" className="delete-item">
        { !hideIcon &&
          <i className="icon-trash"></i>
        }
        {linkText}
        <SimpleModal
          isOpen={this.state.isModalOpen}
          onCloseClick={this.closeModal}
          modalId="delete-item"
          modalClassName="delete-item"
          centered={true}
        >
          <h1>{heading}</h1>
          <p>{body}</p>
          <button onClick={this.closeModal} className="button-primary-inverse">
            Cancel
          </button>
          <button onClick={this.onConfirmClick} className="button-primary">
            Yes, I'm sure
          </button>
        </SimpleModal>
      </a>
    )
  },
  onConfirmClick: function(e) {
    e.preventDefault();
    this.props.onConfirmClick();
    this.closeModal();

    // This is bad!!! We shouldn't be manipulating the DOM directly.
    // See also render method in simple-modal.es6
    $('body').removeClass('modal-open');
  },
  openModal: function(e) {
    e.preventDefault();
    this.setState({ isModalOpen: true });
  },
  closeModal: function() {
    this.setState({ isModalOpen: false });
  }
})

export default DeleteItemLink;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/delete-item-link.es6